<template>
  <div>
    <v-select
      v-model="selectedFruits"
      :items="fruits"
      :rules="rules"
      :disabled="disabled"
      :label="label"
      clearable
      multiple
      dense
      outlined
      @change="change"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="toggle">
          <v-list-item-action>
            <v-icon :color="selectedFruits.length > 0 ? 'primary' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>全选</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0" small>
          <span>{{ item.text }}</span>
        </v-chip>
        <span v-if="index === 1" class="grey--text caption">
          (+{{ value.length - 1 }} )
        </span>
      </template>
    </v-select>
  </div>
</template>
<script>
import { default as StoreApi } from '@/api/pd/common/StoreApi.js'
// let shopList = [{text: "大统华宜兴城中店",value:"1"},{text: "八佰伴锡东成超",value:"1603"},{text: "大统华永乐路店",value:"1024"}]

export default {
  name: 'ShopMultipleSelect',
  data() {
    return {
      fruits: [],
      loading: false,
    }
  },
  props: {
    value: {
      type: Array,
    },
    rules: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    label:{
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  computed: {
    selectedFruits: {
      get: function () {
        console.log('get方法' + this.value)
        if (!this.value) {
          return []
        }
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        console.log('set方法' + val)
        if (!val) {
          val = []
        }
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
    likesAllFruit() {
      return this.selectedFruits.length === this.fruits.length
    },
    likesSomeFruit() {
      return this.selectedFruits.length > 0 && !this.likesAllFruit
    },
    icon() {
      if (this.likesAllFruit) return 'mdi-close-box'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  created() {
    // this.fruits = shopList
    StoreApi.queryStoreList().then(
      (response) => {
        if(response.data.code==200){
          response.data.data.shopPriviledges.concat(response.data.data.shopPriviledges)
          this.fruits = response.data.data.shopPriviledges.map((shop) => {
            return {
              text: shop.shopName,
              value: shop.shopId + '',
            }
          })
          if(this.isSearch){
            this.selectedFruits = response.data.data.shopPriviledges.map((shop) => {
              return shop.shopId + ''
            })
          }
          // console.log('this.fruits',this.fruits)
        }
      }
    )
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedFruits = []
        } else {
          this.selectedFruits = this.fruits.slice().map((item) => {
            return item.value
          })
        }
      })
    },
    change(value) {
      this.$emit('change', value)
    },
  },
}
</script>
